var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m170 700-112.49 140.62c-4.7461 5.9297-11.93 9.3828-19.523 9.3828h-37.984l50-250-50-250h37.984c7.5938 0 14.777 3.4531 19.523 9.3828l112.49 140.62h280l-94.02-470.1c-2.707-13.539 6.0742-26.711 19.613-29.418 1.6133-0.32031 3.2539-0.48438 4.9023-0.48438h19.504c31.02 0 59.766 16.273 75.727 42.875l274.27 457.12h289.04c40.641 0 80.316 12.379 113.75 35.492l20.98 14.508c27.613 19.094 34.52 56.957 15.426 84.57-4.168 6.0312-9.3945 11.258-15.426 15.43l-20.98 14.508c-33.43 23.113-73.105 35.492-113.75 35.492h-289.04l-274.27 457.12c-15.961 26.602-44.707 42.875-75.727 42.875h-19.504c-1.6484 0-3.2891-0.16406-4.9023-0.48438-13.539-2.707-22.32-15.879-19.613-29.418l94.02-470.1zm430-500h100c27.613 0 50 22.387 50 50v50c0 27.613-22.387 50-50 50zm15.145 800 100-150c27.613 0 50 22.387 50 50v50c0 27.613-22.387 50-50 50z",
    fill: "#01447a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneBig);
export default __webpack_public_path__ + "static/media/plane-big.35e8816b942ce9d8be52a75a232ec46e.svg";
export { ForwardRef as ReactComponent };